import { motion } from 'framer-motion';
import { Calendar, BellRing, CalendarCheck } from 'lucide-react';
const KeyBenefits = () => {
  return <section className="py-16 px-4">
    <div className="container mx-auto">
      <h2 className="text-3xl font-bold text-center mb-12">Hogyan segítünk?</h2>

      <div className="grid md:grid-cols-2 gap-8">
        <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
          <div className="bg-medihub-lightPurple p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
            <Calendar className="text-medihub-primary h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold mb-3">Minden esemény egy helyen</h3>
          <p className="text-gray-600">

            Böngéssze át a magyarországi egészségügyi rendezvényeket egy átlátható naptárban és válogasson szakterület, helyszín vagy időpont szerint.</p>
        </motion.div>

        <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
          <div className="bg-medihub-lightPurple p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
            <BellRing className="text-medihub-primary h-6 w-6" />
          </div>
          <h3 className="text-xl font-semibold mb-3">Személyre szabott értesítések</h3>
          <p className="text-gray-600">
            Válassza ki szakterületét és preferenciáit, mi pedig értesítjük, amikor az Ön számára releváns esemény megjelenik a rendszerben.
          </p>
        </motion.div>

      </div>
    </div>
  </section>;
};
export default KeyBenefits;